import { getFromImmutableState } from 'src/utils/immutableUtils';

const _hotelVideoSelector = (state) => state.get('video');
export const hotelVideoSelector = getFromImmutableState(_hotelVideoSelector);
